import React from "react";


// 🔹 Small helper for the animated dots
export const TypingIndicator = () => (
  <div className="coach-bubble them typing">
    <div className="dot"></div>
    <div className="dot"></div>
    <div className="dot"></div>
  </div>
);

export const Icon = {
    AlignLeft: (props) => (
        <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" shapeRendering="geometricPrecision" {...props}>
            <path fill="currentColor" d="M3 5h14v2H3zM3 10h18v2H3zM3 15h12v2H3zM3 20h18v2H3z" />
        </svg>
    ),
    AlignCenter: (props) => (
        <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" shapeRendering="geometricPrecision" {...props}>
            <path fill="currentColor" d="M5 5h14v2H5zM3 10h18v2H3zM7 15h10v2H7zM3 20h18v2H3z" />
        </svg>
    ),
    AlignRight: (props) => (
        <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" shapeRendering="geometricPrecision" {...props}>
            <path fill="currentColor" d="M7 5h14v2H7zM3 10h18v2H3zM11 15h10v2H11zM3 20h18v2H3z" />
        </svg>
    ),
    Undo: (props) => (
        <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" shapeRendering="geometricPrecision" {...props}>
            <path fill="currentColor" d="M12.5 8c-2.65 0-5.05 1.04-6.83 2.73L2.5 7.5v9h9l-3.19-3.19c1.33-1.13 3.06-1.81 4.94-1.81 3.31 0 6.13 2.13 7.16 5.09l2.09-.72C21.2 11.97 17.22 8 12.5 8z" />
        </svg>
    ),
    Redo: (props) => (
        <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" shapeRendering="geometricPrecision" {...props}>
            <path fill="currentColor" d="M18.33 10.73C16.55 9.04 14.15 8 11.5 8c-4.72 0-8.7 3.97-9.96 7.87l2.09.72A8.004 8.004 0 0 1 11.5 11.5c1.88 0 3.61.68 4.94 1.81L13.25 16.5h9v-9l-3.17 3.23z" />
        </svg>
    ),
    Eraser: (props) => (
        <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" shapeRendering="geometricPrecision" {...props}>
            <path fill="currentColor" d="M16.5 3.5l4 4a2 2 0 010 2.8L12 18.8a2 2 0 01-1.4.6H6a2 2 0 01-1.4-.6l-4-4a2 2 0 010-2.8L11.1 3.5a2 2 0 012.8 0zm-8 14.9h2.9l7.7-7.7-2.9-2.9-7.7 7.7z" />
        </svg>
    ),
    Coach: (props) => (
        <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            aria-hidden="true"
            shapeRendering="geometricPrecision"
            {...props}
        >
            {/* Pen nib (center) */}
            <path
            fill="currentColor"
            d="M12 2a2 2 0 0 1 2 2v2.8l4.6 4.6-5.9 5.9V20a2 2 0 1 1-4 0v-1.7L2.8 11.6 7.4 7V4a2 2 0 0 1 2-2h2.6Zm0 8.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Z"
            />
            {/* Dumbbell (behind/through the nib) */}
            <path
            fill="currentColor"
            d="M3 9.75h2v4.5H3c-.55 0-1-.45-1-1v-2.5c0-.55.45-1 1-1Zm4.5-1.75h2v8h-2c-.55 0-1-.45-1-1V9c0-.55.45-1 1-1Zm9 10h-2v-8h2c.55 0 1 .45 1 1v6c0 .55-.45 1-1 1Zm2.5-8.25H21c.55 0 1 .45 1 1v2.5c0 .55-.45 1-1 1h-2v-4.5Z"
            opacity=".9"
            />
        </svg>
        ),
    Chat: (props) => (
        <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            aria-hidden="true"
            shapeRendering="geometricPrecision"
            {...props}
        >
            <path
                fill="currentColor"
                d="M4 4.5h16a2.5 2.5 0 0 1 2.5 2.5v8A2.5 2.5 0 0 1 20 17.5H10.1l-4.6 3.4a.8.8 0 0 1-1.28-.64V17.5H4A2.5 2.5 0 0 1 1.5 15V7A2.5 2.5 0 0 1 4 4.5Zm2.3 4.2a1 1 0 1 0 0 2h11.4a1 1 0 1 0 0-2H6.3Zm0 3.9a1 1 0 1 0 0 2h8.2a1 1 0 1 0 0-2H6.3Z"
            />
        </svg>
    ),

    Close: (props) => (
        <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" shapeRendering="geometricPrecision" {...props}>
            <path fill="currentColor" d="M18.3 5.71L12 12.01l-6.29-6.3-1.42 1.42L10.59 13.4l-6.3 6.29 1.42 1.42 6.29-6.3 6.29 6.3 1.42-1.42-6.3-6.29 6.3-6.29z" />
        </svg>
    ),
    Restart: (props) => (
       <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            aria-hidden="true"
            shapeRendering="geometricPrecision"
            {...props}
        >
            <path
            fill="currentColor"
            d="M15.88 13.84c-1.68-3.48-5.44-5.24-9.04-4.6l.96-1.8c.24-.4.08-.92-.32-1.12-.4-.24-.92-.08-1.12.32l-1.96 3.64s-.44.72.24 1.04l3.64 1.96c.12.08.28.12.4.12.28 0 .6-.16.72-.44.24-.4.08-.92-.32-1.12l-1.88-1.04c2.84-.48 5.8.96 7.12 3.68 1.6 3.32.2 7.32-3.12 8.88-1.6.76-3.4.88-5.08.28s-3.04-1.8-3.8-3.4c-.76-1.6-.88-3.4-.28-5.08.16-.44-.08-.92-.52-1.08-.4-.08-.88.16-1.04.6-.72 2.12-.6 4.36.36 6.36s2.64 3.52 4.76 4.28c.92.32 1.84.48 2.76.48 1.24 0 2.48-.28 3.6-.84 4.16-2 5.92-7 3.92-11.12Z"
            transform="translate(-1, -1)"
            />
        </svg>
    ),
    Edit: (props) => (
        <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            aria-hidden="true"
            shapeRendering="geometricPrecision"
            {...props}
        >
            <path
                fill="currentColor"
                d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
            />
        </svg>
    ),
    Agent: (props) => (
        <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            aria-hidden="true"
            shapeRendering="geometricPrecision"
            {...props}
        >
            {/* Sparkle / wand - represents AI analysis */}
            <path
                fill="currentColor"
                d="M12 2L13.09 8.26L18 6L14.74 10.91L21 12L14.74 13.09L18 18L13.09 15.74L12 22L10.91 15.74L6 18L9.26 13.09L3 12L9.26 10.91L6 6L10.91 8.26L12 2Z"
            />
        </svg>
    ),
    Scenes: (props) => (
        <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            aria-hidden="true"
            shapeRendering="geometricPrecision"
            {...props}
        >
            {/* Film clapperboard */}
            <path
                fill="currentColor"
                d="M20 4h-1.5l-2.09 2.09L18.5 8H20V4zm-4 0h-2.09l-2.09 2.09L14 8h2.09l2.09-2.09L16 4zm-4.5 0H9.41l-2.09 2.09L9.5 8h2.09l2.09-2.09L11.5 4zM7 4H4v4h1.5l2.09-2.09L5.5 4H7zM4 10v10h16V10H4zm7 8H6v-2h5v2zm7 0h-5v-2h5v2zm0-4H6v-2h12v2z"
            />
        </svg>
    ),
    ShowVsTell: (props) => (
        <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" shapeRendering="geometricPrecision" {...props}>
            {/* Eye with pen — show vs tell */}
            <path fill="currentColor" d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zm0 12.5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
        </svg>
    ),
    Pacing: (props) => (
        <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" shapeRendering="geometricPrecision" {...props}>
            {/* Speedometer / gauge — pacing */}
            <path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.54-12.46l-1.42 1.42L12 11.59l-2.12-2.13-1.42 1.42L10.59 13l-2.13 2.12 1.42 1.42L12 14.41l2.12 2.13 1.42-1.42L13.41 13l2.13-2.12z" />
        </svg>
    ),
    Hooks: (props) => (
        <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" shapeRendering="geometricPrecision" {...props}>
            {/* Hook / anchor — chapter hooks */}
            <path fill="currentColor" d="M17 15c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.87 3.13 7 7 7s7-3.13 7-7h-2zm-4-2V7h2l-3-4-3 4h2v6h2z" />
        </svg>
    ),
    Holes: (props) => (
        <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" shapeRendering="geometricPrecision" {...props}>
            {/* Warning triangle — inconsistencies / holes */}
            <path fill="currentColor" d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
        </svg>
    ),
    Characters: (props) => (
        <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" shapeRendering="geometricPrecision" {...props}>
            {/* People group — characters */}
            <path fill="currentColor" d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
        </svg>
    ),
    PlotStructure: (props) => (
        <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" shapeRendering="geometricPrecision" {...props}>
            {/* Timeline / flow chart — plot structure */}
            <path fill="currentColor" d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z" />
        </svg>
    ),
    RewritePlan: (props) => (
        <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" shapeRendering="geometricPrecision" {...props}>
            {/* Clipboard with checklist — rewrite plan */}
            <path fill="currentColor" d="M19 3h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-2 14l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z" />
        </svg>
    ),
    ProjectIssues: (props) => (
        <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" shapeRendering="geometricPrecision" {...props}>
            {/* Flag — project-level issues */}
            <path fill="currentColor" d="M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6h-5.6z" />
        </svg>
    ),
    Board: (props) => (
        <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" shapeRendering="geometricPrecision" {...props}>
            {/* Kanban board with three columns and cards */}
            <path fill="currentColor" d="M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2zm0 2v12h16V6H4zm2 2h3v2H6V8zm0 4h3v4H6v-4zm5-4h3v4h-3V8zm0 6h3v2h-3v-2zm5-6h2v2h-2V8zm0 4h2v4h-2v-4z" />
        </svg>
    ),
    Progress: (props) => (
        <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" shapeRendering="geometricPrecision" {...props}>
            {/* Circular progress ring with upward trend */}
            <path fill="none" stroke="currentColor" strokeWidth="1.8" d="M12 3.5a8.5 8.5 0 1 0 8.5 8.5" />
            <path fill="currentColor" d="M19.8 3.8h-4.2a.9.9 0 0 0 0 1.8h2.02L14 9.22a.9.9 0 1 0 1.28 1.28l3.62-3.62v2.02a.9.9 0 1 0 1.8 0V4.7a.9.9 0 0 0-.9-.9z" />
            <path fill="currentColor" d="M7.1 14.9a.9.9 0 0 1 .9-.9h8a.9.9 0 1 1 0 1.8H8a.9.9 0 0 1-.9-.9z" opacity="0.75" />
        </svg>
    ),
    Tools: (props) => (
        <svg width="50" height="50" viewBox="0 -32 576 576" aria-hidden="true" shapeRendering="geometricPrecision" {...props}>
            <path fill="currentColor" d="M571.31 193.94l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31-28.9-28.9c5.63-21.31.36-44.9-16.35-61.61l-45.25-45.25c-62.48-62.48-163.79-62.48-226.28 0l90.51 45.25v18.75c0 16.97 6.74 33.25 18.75 45.25l49.14 49.14c16.71 16.71 40.3 21.98 61.61 16.35l28.9 28.9-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l90.51-90.51c6.23-6.24 6.23-16.37-.02-22.62zm-286.72-15.2c-3.7-3.7-6.84-7.79-9.85-11.95L19.64 404.96c-25.57 23.88-26.26 64.19-1.53 88.93s65.05 24.05 88.93-1.53l238.13-255.07c-3.96-2.91-7.9-5.87-11.44-9.41l-49.14-49.14z" />
        </svg>
    ),
    Clipboard: (props) => (
        <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" shapeRendering="geometricPrecision" {...props}>
            {/* Clipboard sheet */}
            <path fill="currentColor" d="M9 2h6a2 2 0 0 1 2 2h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2a2 2 0 0 1 2-2zm0 4H7v1h10V6h-2v1H9V6zm-2 5h10v2H7v-2zm0 4h10v2H7v-2z" />
        </svg>
    ),
    SearchLoop: (props) => (
        <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" shapeRendering="geometricPrecision" {...props}>
            <path fill="currentColor" d="M10.5 3a7.5 7.5 0 1 0 4.74 13.31l4.22 4.22a1.1 1.1 0 0 0 1.56-1.56l-4.22-4.22A7.5 7.5 0 0 0 10.5 3zm0 2.2a5.3 5.3 0 1 1 0 10.6 5.3 5.3 0 0 1 0-10.6z" />
        </svg>
    ),
    StoryBible: (props) => (
        <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" shapeRendering="geometricPrecision" {...props}>
            {/* Open book — story bible */}
            <path fill="currentColor" d="M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1zm0 13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z" />
        </svg>
    ),
    Share: (props) => (
        <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" shapeRendering="geometricPrecision" {...props}>
            {/* Share icon - arrow pointing outward */}
            <path fill="currentColor" d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.15c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.56 9.31 6.88 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.88 0 1.56-.31 2.04-.81l7.12 4.15c-.05.21-.08.43-.08.66 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z" />
        </svg>
    ),
    Reflection: (props) => (
        <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" shapeRendering="geometricPrecision" {...props}>
            {/* Mirror frame */}
            <rect x="6" y="3" width="12" height="14" rx="6" fill="none" stroke="currentColor" strokeWidth="1.8" />
            {/* Reflective glass */}
            <rect x="8" y="5" width="8" height="10" rx="4" fill="currentColor" opacity="0.2" />
            {/* Mirror highlight */}
            <path fill="currentColor" d="M9.6 6.4a.9.9 0 0 1 .9-.9h1.6a.9.9 0 1 1 0 1.8h-1.6a.9.9 0 0 1-.9-.9z" opacity="0.55" />
            {/* Stand neck */}
            <rect x="11" y="17" width="2" height="2.2" rx="1" fill="currentColor" />
            {/* Stand base */}
            <path fill="currentColor" d="M8 21a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1z" />
        </svg>
    ),
};

